import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { ParkingLotWithExt } from "@onsip/web/features/administrators/parkingLot/parkingLotPage/parking-lot-page.component";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-parking-lot-settings-view",
  templateUrl: "./parking-lot-settings-view.component.html",
  styleUrls: ["../../parkingLotShelfContainer/parking-lot-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ParkingLotSettingsViewComponent implements OnInit {
  @Input() parkLot!: ParkingLotWithExt;
  @Output() editPanel = new EventEmitter<void>();
  mobileView!: Observable<boolean>;
  E2eLocators = E2eLocators;
  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.mobileView = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(map(res => res.matches));
  }
}
